
export default function ListMenu({ userType }) {
 
  const columns = [
    ...(userType === 1 ? [{ key: "super_username", label: "SUPER",className: "menuUsername" }] : []),
    ...(userType === 1 || userType === 2
      ? [{ key: "master_username", label: "MASTER",className: "menuUsername" }]
      : []),
    ...(userType === 1 ||
    userType === 2 ||
    userType === 3 ||
    userType === 5 ||
    userType === 6
      ? [{ key: "username", label: "USER",className: "menuUsername" }]
      : []),
    { key: "acc_id", label: "ACC ID", className: "menuUsername" },
    { key: "acc_name", label: "ACC NAME", className: "menuUsername" },
    { key: "id", label: "ID", className: "menuUsername" },
    { key: "amount", label: "AMOUNT", className: "menuUsername" },
    { key: "slip", label: "SLIP", className: "menuUsername" },
    { key: "utr", label: "UTR", className: "menuUsername" },
    { key: "msg", label: "MSG", className: "menuUsername addFlex" },
    { key: "success", label: "SUCCESS", className: "menuUsername small" },
    { key: "reject", label: "REJECT", className: "menuUsername small" },
    { key: "date", label: "DATE", className: "menuUsername" },
    { key: "other", label: "OTHER", className: "menuUsername" },
    { key: "status", label: "STATUS", className: "menuUsername addFlex" },
  ];

  return (
    <div className="menuContainer primary white">
      {columns.map(({ key, label, className = "menuExchange" }) => (
        <div
          key={key}
          className={`${className} ${userType === 1 || userType === 2 ? "small" : null}`}
          style={{ cursor: "pointer" }}
        >
          {label}
        </div>
      ))}
    </div>
  );
}
